import ClickAndCollectStoreIcon from './ClickAndCollectStoreIcon';

export default ClickAndCollectStoreIcon;
